import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import {
    Cities
} from "../../../../shared/models/classes/Dashboard/cityData/city-data";
import { DashboardBizzDevService } from "../../../../shared/services/dashboard-bizz-dev.service";

@Component({
    selector: "app-flanders-cities",
    templateUrl: "./flanders-cities.component.html",
    styleUrls: ["./flanders-cities.component.scss"],
})
export class FlandersCitiesComponent implements OnInit, AfterViewInit {
    constructor(
        private dashboardService: DashboardBizzDevService,
        private router: Router
    ) {}

    bbcCitiesDataYear: Cities;
    displayedColumns = [
        "fullLabel",
        "lastRealizedYear",
        "lastMJPYear",
        "importDate",
        "licenceType",
        "lastConnexionDate",
    ];
    dataSource;
    dateElement: string;

    @ViewChild(MatSort)
    sort: MatSort;

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        this.getFlandersCityData();
    }

    getFlandersCityData(): void {
        this.dashboardService.getCityData("bbc2020").subscribe((value) => {
            this.dataSource = new MatTableDataSource(value);
            this.bbcCitiesDataYear = value;
            if (this.sort) {
                this.dataSource.sort = this.sort;
            }
        });
    }

    doFilter = (value: string) => {
        this.dataSource.filter = value.trim().toLocaleLowerCase();
    };
    loadCityDetails(id: number) {
        this.router.navigate(["/dashboardBizzDev/details/cityDetails", id]);
    }
}
